import React, { useEffect } from "react";
import { ExternalLink, Music2, X } from "lucide-react";

export default function MusicEmbedModal({ player, title = "Unlimited Session", onClose }) {
  useEffect(() => {
    if (!player?.embedUrl) return undefined;
    const previousOverflow = document.body.style.overflow;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [player?.embedUrl, onClose]);

  if (!player?.embedUrl) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/85 p-4 text-white backdrop-blur-md"
      role="dialog"
      aria-modal="true"
      aria-label="Lecteur Spotify intégré"
      onMouseDown={onClose}
    >
      <div
        className="w-full max-w-[720px] overflow-hidden rounded-lg border border-white/10 bg-[#101010] shadow-2xl"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-4 border-b border-white/10 px-4 py-4 md:px-5">
          <div className="min-w-0">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-red-500">
              <Music2 size={15} /> Lecture Spotify
            </p>
            <h2 className="mt-2 truncate text-lg font-black uppercase md:text-2xl">
              {title}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-white/10 text-white transition hover:bg-white hover:text-black"
            aria-label="Fermer le lecteur"
          >
            <X size={19} />
          </button>
        </div>

        <div className="bg-black p-3 md:p-5">
          <iframe
            title={`Spotify - ${title}`}
            src={player.embedUrl}
            width="100%"
            height={player.type === "track" || player.type === "episode" ? "352" : "432"}
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            className="block w-full rounded-lg border-0 bg-black"
          />
        </div>

        <div className="flex flex-col gap-3 border-t border-white/10 px-4 py-4 text-sm text-gray-400 md:flex-row md:items-center md:justify-between md:px-5">
          <span>
            Le son reste ici. Spotify peut demander une action manuelle pour lancer la lecture.
          </span>
          <a
            href={player.originalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-bold uppercase tracking-wide text-white transition hover:border-white hover:bg-white hover:text-black"
          >
            Ouvrir Spotify <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </div>
  );
}
